const MAIN_URL = 'https://george-fx.github.io/dinehub_api/';

export const GET_MENU = `${MAIN_URL}api/menu.json`;
export const GET_DISHES = `${MAIN_URL}api/dishes.json`;
export const GET_ORDERS = `${MAIN_URL}api/orders.json`;
export const GET_REVIEWS = `${MAIN_URL}api/reviews.json`;
export const GET_BANNERS = `${MAIN_URL}api/banners.json`;
export const GET_CAROUSEL = `${MAIN_URL}api/carousel.json`;
export const GET_PROMOCODES = `${MAIN_URL}api/promocodes.json`;
export const GET_CATEGORIES = `${MAIN_URL}api/categories.json`;
export const GET_NOTIFICATIONS = `${MAIN_URL}api/notifications.json`;

export const URLS = {
  GET_MENU,
  GET_ORDERS,
  GET_DISHES,
  GET_BANNERS,
  GET_REVIEWS,
  GET_CAROUSEL,
  GET_PROMOCODES,
  GET_CATEGORIES,
  GET_NOTIFICATIONS,
};
